import ApiService from '../util/api';
import * as ActionType from './types/AccountInvitationActionTypes';

export function requestPartnerStatus() {
  return {
    type: ActionType.REQUEST_PARTNER_STATUS,
  };
}

export function receivePartnerStatus(response) {
  return {
    type: ActionType.RECEIVE_PARTNER_STATUS,
    payload: response,
  };
}

export function getPartnerAccount() {
  return dispatch => {
    dispatch(requestPartnerStatus());
    return ApiService.get('/web-api/v1/account-invitation/list')
      .then(json => dispatch(receivePartnerStatus(json)))
      .catch(err => {
        throw new Error((err && err.message) || 'Sorry, we were unable to process your request');
      });
  };
}

export function invitePartner(data) {
  return dispatch =>
    ApiService.post('/web-api/v1/account-invitation/send', data)
      .then(json => dispatch(receivePartnerStatus([json]))) // make array to match structure of getPartnerAccount
      .catch(err => {
        throw new Error((err && err.message) || 'Sorry, we were unable to process your request');
      });
}

export function removeOrRevokePartner(uuid, removeOrRevoke) {
  return dispatch =>
    ApiService.post(`/web-api/v1/account-invitation/uuid/${uuid}/${removeOrRevoke}`)
      .then(() => dispatch(receivePartnerStatus([])))
      .catch(err => {
        throw new Error((err && err.message) || 'Sorry, we were unable to process your request');
      });
}



// WEBPACK FOOTER //
// ./src/actions/AccountInvitationActions.js